// The settings (exchange rates and KPI targets) as the screens read them. Loaded once at start-up from the server
// and replaced when Ibraheem saves new ones. Pages read them while they draw, so a page opened after a change shows the new numbers.
import { useSyncExternalStore } from 'react';
import { DEFAULT_SETTINGS, type Settings } from '@serb/shared';

let current: Settings = DEFAULT_SETTINGS;
const listeners = new Set<() => void>();

export const getSettings = () => current;

export function setSettings(next: Settings) {
  current = next;
  listeners.forEach((l) => l());
}

/** For the Settings page: re-draws when the settings change */
export function useSettings(): Settings {
  return useSyncExternalStore((l) => {
    listeners.add(l);
    return () => listeners.delete(l);
  }, getSettings);
}
